import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-24-hidden.tsx
/**
* icon.24.hidden
*
* Keywords: eye, closed, sleep, invisible, privacy, eyelash, hide, rest
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZmlsbC1ydWxlPSJldmVub2RkIiBkPSJNNS41IDljLjI3NiAwIC41MzMuMjIzLjY0MS40NzdxLjA2NS4xNTMuMTcyLjM0OGMuMjQuNDM1LjYxMy45MzggMS4xMjEgMS40MTRDOC40NDIgMTIuMTg0IDkuOTU0IDEzIDEyIDEzczMuNTU4LS44MTYgNC41NjYtMS43NmMuNTA4LS40NzcuODgtLjk4IDEuMTIxLTEuNDE1cS4xMDctLjE5NS4xNzEtLjM0OGMuMTEtLjI1NC4zNjYtLjQ3Ny42NDItLjQ3N3MuNDk1LjIyNS40MTcuNDljLS4yMDIuNjgyLS43NyAxLjY1LTEuNzA1IDIuNTE1bDEuMTQyIDEuMTQxYS41LjUgMCAwIDEtLjcwOC43MDhsLTEuMjE3LTEuMjE4YTcuNCA3LjQgMCAwIDEtMS44OS45NThsLjQ0NiAxLjc4NWEuNS41IDAgMCAxLS45Ny4yNDJsLS40NDMtMS43N0E4IDggMCAwIDEgMTIgMTRhOCA4IDAgMCAxLTEuNTcyLS4xNWwtLjQ0MyAxLjc3MWEuNS41IDAgMCAxLS45Ny0uMjQybC40NDYtMS43ODVhNy40IDcuNCAwIDAgMS0xLjg5LS45NThsLTEuMjE3IDEuMjE4YS41LjUgMCAwIDEtLjcwOC0uNzA4bDEuMTQyLTEuMTQyYy0uOTM1LS44NjQtMS41MDMtMS44MzItMS43MDUtMi41MTQtLjA3OC0uMjY1LjE0LS40OS40MTctLjQ5IiBjbGlwLXJ1bGU9ImV2ZW5vZGQiLz48L3N2Zz4=)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=1-1141
*/
const Icon24Hidden = memo(function Icon24Hidden(props) {
	return /* @__PURE__ */ jsx("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			fillRule: "evenodd",
			d: "M5.5 9c.276 0 .533.223.641.477q.065.153.172.348c.24.435.613.938 1.121 1.414C8.442 12.184 9.954 13 12 13s3.558-.816 4.566-1.76c.508-.477.88-.98 1.121-1.415q.107-.195.171-.348c.11-.254.366-.477.642-.477s.495.225.417.49c-.202.682-.77 1.65-1.705 2.515l1.142 1.141a.5.5 0 0 1-.708.708l-1.217-1.218a7.4 7.4 0 0 1-1.89.958l.446 1.785a.5.5 0 0 1-.97.242l-.443-1.77A8 8 0 0 1 12 14a8 8 0 0 1-1.572-.15l-.443 1.771a.5.5 0 0 1-.97-.242l.446-1.785a7.4 7.4 0 0 1-1.89-.958l-1.217 1.218a.5.5 0 0 1-.708-.708l1.142-1.142c-.935-.864-1.503-1.832-1.705-2.514-.078-.265.14-.49.417-.49",
			clipRule: "evenodd"
		})
	});
});
//#endregion
export { Icon24Hidden };

//# sourceMappingURL=icon-24-hidden.js.map